/* RESPONSIBLE TEAM: team-help-desk-experience */

import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';

export default class MultilingualRoute extends SettingsRoute {
  @service declare intl: IntlService;

  analytics = {
    section: 'settings',
    place: 'personal.multilingual',
  };

  get titleToken() {
    return this.intl.t('new-settings.submenu.personal.multilingual');
  }
}
